import { useEffect, useRef } from "react";
import { getLocalJWT, getLocalUserId } from "../functions/utilities";
import { socketInit } from "./socketInit";

export interface GstJobUpdate {
  jobId: string | number;
  jobType: "gst_fetch_data" | "sanity_check" | "run_recon" | string;
  status:
    | "pending"
    | "running"
    | "connected"
    | "completed"
    | "completed_with_errors"
    | "failed"
    | "cancelled";
  gstin?: string;
  processStatus?: Record<string, string>;
  error?: {
    code?: string;
    message?: string;
  } | null;
  data?: {
    processStatus?: string;
    stepIndex?: number;
    rowCount?: number;
    error?: string;
    fileId?: string;
    monthsDone?: string[];
    totalRows?: number;
  };
}

export function useGstReconSocket(onUpdate: (update: GstJobUpdate) => void) {
  const socketRef = useRef<ReturnType<typeof socketInit> | null>(null);
  const onUpdateRef = useRef(onUpdate);
  onUpdateRef.current = onUpdate;

  useEffect(() => {
    const userId = getLocalUserId();
    const token = getLocalJWT();
    if (!userId || !token) return;

    const socket = socketInit(userId.toString(), token);
    socketRef.current = socket;

    const joinRoom = () => {
      socket.emit("JOIN_GST_ROOM");
    };

    const handleJobStarted = (data: GstJobUpdate) => {
      console.log("[GST_SOCKET] GST_JOB_STARTED", data);
      onUpdateRef.current(data);
    };

    const handleJobUpdate = (data: GstJobUpdate) => {
      console.log("[GST_SOCKET] GST_RECON_JOB_UPDATE", data);
      onUpdateRef.current(data);
    };

    socket.on("connect", joinRoom);
    socket.on("GST_JOB_STARTED", handleJobStarted);
    socket.on("GST_RECON_JOB_UPDATE", handleJobUpdate);

    // Join immediately in case already connected
    if (socket.connected) joinRoom();

    return () => {
      socket.off("connect", joinRoom);
      socket.off("GST_JOB_STARTED", handleJobStarted);
      socket.off("GST_RECON_JOB_UPDATE", handleJobUpdate);
      socket.disconnect();
    };
  }, []);
}
